import React from "react";
import { convertFromRaw } from "draft-js";
import { stateToHTML } from "draft-js-export-html";

const DetailView = ({ rawContent }) => {
  const contentState = convertFromRaw(rawContent);
  const htmlContent = stateToHTML(contentState);

  return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
};

export default DetailView;
